export const shouldPinPrimaryColumnLeft = (
  columns: { id?: string }[],
  primaryColumnIds: string[],
): boolean => columns.every((col) => primaryColumnIds.includes(col.id ?? ""));
